// src/Studio/timeline/fxRuntime.shared.ts
//
// Tiny shared math helpers used by both fxRuntime.ts (core) and
// fxRuntime.evaluation.ts. Extracted to break a circular import.

export function clamp01(value: number): number {
  return Math.max(0, Math.min(1, value));
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export function toFinite(value: unknown, fallback: number): number {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export function hash01(value: number): number {
  const x = Math.sin(value * 12.9898 + 78.233) * 43758.5453;
  return x - Math.floor(x);
}

export function hashSigned(value: number): number {
  return hash01(value) * 2 - 1;
}
